import { useRouter } from 'next/router';

export const useIsCheckoutOptionsPage = () => {
  const router = useRouter();
  return router.route === '/[locationSlug]/[merchantSlug]/[merchantId]/checkout-type';
};
